// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1m9in","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__YoZWs"};